import { memo } from "react";
import type { PopupProps } from "../../interfaces/popupProps";
import "./Popup.scss";

export const AlertPopup: React.FC<PopupProps> = memo(
  ({ onConfirm, message, confirmText, title }) => {
    return (
      <div className="modal-overlay">
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal_container modal_container--small">
            <div className="modal-body">
              <h3>{title}</h3>

              <p>{message}</p>
            </div>
            <div className="modal-footer">
              <div className="cta cta--block">
                <button className="btn btn-danger" onClick={onConfirm}>
                  {confirmText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

AlertPopup.displayName = "AlertPopup";
